<template>
  <div>
    <div
      :class="`d-flex align-items-center pl-2 pr-3 ${isMoveAction ? 'rounded' : ''}`"
      :style="{
        'margin-left': `-${(value.nestingCount + 1) * 18}px`,
        'background-color': `${isChecked ? 'rgba(34, 96, 255, 0.05)' : ''}`,
      }"
    >
      <div :class="`mt-1 pt-1 pl-1 ${isMoveAction && isParentOfSelectedFolder ? 'invisible' : ''}`">
        <b-form-checkbox
          :checked="isChecked"
          :style="{ 'padding-left': 0, 'padding-right': `${(value.nestingCount + (isMoveAction ? 1 : 0)) * 18}px` }"
          :class="{ 'rounded-checkbox': isMoveAction }"
          @change="() => onUserAccessChange(value)"
        />
      </div>
      <div class="d-flex align-items-center my-2 pl-2px">
        <div
          v-if="!isMainFolder"
          :class="{ invisible: value.type === 'file' }"
          @click="() => onChangeTreeHandler(value)"
        >
          <CollapseIcon :class="`${value.isOpen ? 'active-collapse' : 'disable-collapse'} ${isSelected ? 'selected-item' : ''}`" />
        </div>
        <FolderIcon
          v-if="value.type === 'folder' && !isMainFolder"
          :class="`${value.isOpen ? 'active-folder-icon' : 'disable-folder-icon'} ${isSelected ? 'selected-item' : ''}`"
        />
        <component
          :is="fileIcons[value.fileType] || fileIcons['*']"
          v-if="value.type === 'file'"
          class="files-icon"
        />
        <RootFolderIcon v-if="value.type === 'rootFolder'" class="active-folder-icon" />
        <p :class="`folder-name ${value.isOpen ? 'folder-name-active' : ''} ${isSelected ? 'selected-item' : ''}`">
          {{ value.name }}
        </p>
      </div>
    </div>
    <div
      v-if="value.isOpen"
      class="pl-18"
    >
      <FolderTree
        v-for="childValue in currentChildList"
        :key="childValue.id"
        :value="childValue"
        :on-change-tree-handler="onChangeTreeHandler"
        :user-access-list="userAccessList"
        :on-user-access-change="onUserAccessChange"
        :action-type="actionType"
        :selected-structure="selectedStructure"
      />
    </div>
  </div>
</template>

<script>
import CollapseIcon from '../../../../assets/icons/iconsCode/collapse.vue';
import FolderIcon from '../../../../assets/icons/iconsCode/folder.vue';
import JpgFileIcon from '../../../../assets/icons/iconsCode/jpg-file.vue';
import PngFileIcon from '../../../../assets/icons/iconsCode/png-file.vue';
import PptFileIcon from '../../../../assets/icons/iconsCode/ppt-file.vue';
import TxtFileIcon from '../../../../assets/icons/iconsCode/txt-file.vue';
import XlsFileIcon from '../../../../assets/icons/iconsCode/xls-file.vue';
import DocFileIcon from '../../../../assets/icons/iconsCode/doc-file.vue';
import PdfFileIcon from '../../../../assets/icons/iconsCode/pdf-file.vue';
import ZipFileIcon from '../../../../assets/icons/iconsCode/zip-file.vue';
import RootFolderIcon from '../../../../assets/icons/iconsCode/root-folder.vue';
import UnknownFileIcon from '../../../../assets/icons/iconsCode/unknown-file.vue';

export default {
  name: 'FolderTree',
  components: {
    CollapseIcon,
    FolderIcon,
    JpgFileIcon,
    PngFileIcon,
    PptFileIcon,
    TxtFileIcon,
    XlsFileIcon,
    DocFileIcon,
    PdfFileIcon,
    ZipFileIcon,
    RootFolderIcon,
    UnknownFileIcon,
  },
  props: {
    value: {
      type: Object,
      default: () => {},
    },
    onChangeTreeHandler: {
      type: Function,
      default: () => {},
    },
    userAccessList: {
      type: Array,
      default: () => [],
    },
    onUserAccessChange: {
      type: Function,
      default: () => {},
    },
    actionType: {
      type: String,
      default: '',
    },
    selectedStructure: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {};
  },
  computed: {
    isChecked() {
      return this.userAccessList.includes(this.value.id);
    },
    fileIcons() {
      return {
        'image/jpeg': JpgFileIcon,
        'image/png': PngFileIcon,
        'application/vnd.ms-powerpoint': PptFileIcon,
        'application/vnd.openxmlformats-officedocument.presentationml.presentation': PptFileIcon,
        'text/plain': TxtFileIcon,
        'application/vnd.ms-excel': XlsFileIcon,
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': XlsFileIcon,
        'application/msword': DocFileIcon,
        'application/vnd.openxmlformats-officedocument.wordprocessingml.document': DocFileIcon,
        'application/pdf': PdfFileIcon,
        'application/zip': ZipFileIcon,
        'application/x-zip-compressed': ZipFileIcon,
        '*': UnknownFileIcon,
      };
    },
    isMoveAction() {
      return this.actionType === 'move';
    },
    isSelected() {
      return this.isMoveAction && this.isChecked;
    },
    isParentOfSelectedFolder() {
      return this.selectedStructure.owned === this.value.id;
    },
    isMainFolder() {
      return this.value.id === 'mainFolder';
    },
    currentChildList() {
      if (this.selectedStructure) {
        return this.value.childList.filter(({ id }) => id !== this.selectedStructure.id);
      }
      return this.value.childList;
    },
  },
};
</script>

<style lang="scss" scoped>
.active-collapse {
  color: #2260FF;
  transform: rotate(90deg);
  margin-right: 8px;
  cursor: pointer;
}
.disable-collapse {
  color: #C5D0DE;
  margin-right: 8px;
  cursor: pointer;
}
.files-icon {
  width: 20px;
  height: 20px;
  margin-right: 10px;
}
.active-folder-icon {
  color: #2260FF;
  margin-right: 10px;
}
.disable-folder-icon {
  color: #C5D0DE;
  margin-right: 10px;
}
.folder-name {
  color: #646A87;
  font-family: 'Poppins';
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  margin: 0;
}
.folder-name-active {
  color: #2260FF;
}
.pl-18 {
  padding-left: 18px;
}
.pl-2px {
  padding-left: 2px;
}
.selected-item {
  color: #0F2041;
}
::v-deep .custom-checkbox .custom-control-label::before {
  border: 1px solid #646A87;
  border-radius: 4px;
}
::v-deep .custom-control-input:checked ~ .custom-control-label::before {
  border: 1px solid #2260FF;
}
::v-deep .custom-checkbox .custom-control-input:checked ~ .custom-control-label::after {
  border-radius: 2px;
}
::v-deep .rounded-checkbox .custom-control-label::before {
  border-radius: 50%;
}
::v-deep .rounded-checkbox .custom-control-input:checked ~ .custom-control-label::after {
  border-radius: 50%;
}
</style>
